<template>
  <!-- 关于我们 -->
  <div class="box abus">
    <div class="abusm0"></div>

    <div class="swiper-container abus_menu gallery-thumbs">
      <div class="swiper-wrapper">
        <div
          v-for="(item, index) in arr"
          :key="item"
          class="swiper-slide"
          @click="changeMenu(index)"
        >
          {{ item }}
        </div>
      </div>
    </div>

    <div class="swiper-container gallery-top">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <!-- 企业文化 -->
          <div class="wh1">
            <h4 class="blue_h4">企业文化</h4>
            <ul class="wh_ul">
              <li v-for="item in arr1" :key="item.id">
                <p>{{ item.dec }}</p>
                <div>{{ item.tit }}</div>
              </li>
            </ul>
          </div>

          <div class="wh2">
            <div class="gary_tit">员工活动</div>
            <ul class="wh2_ul">
              <li
                v-for="(item, index) in yglist"
                :key="item.id"
                @click="goInfo(item)"
              >
                <img :src="item.url" :alt="item.title" />
                <div>
                  <p>{{ item.title }}</p>
                  <span>{{ item.describe }}</span>
                </div>
              </li>
            </ul>

            <a
              v-if="yglist.length == 3"
              class="loading_more"
              href="javascript:void(0)"
              @click="goGameFoto(1)"
              >查看更多</a
            >
          </div>
        </div>
        <div class="swiper-slide">
          <!-- 核心团队 -->
          <div class="td1">
            <div class="td1_box">
              <h4 class="blue_h4">车镇团队</h4>
              <p>
                车镇自创业初始就确立了“以人为本”的战略，十分注重人才培养和团队文化建设。历经四年蓬勃发展，车镇已拥有一支年轻、有激情、敢于拼搏、勇于创新的上百人团队。
              </p>
            </div>
            <img class="wlphobe" :src="picUrl + 'td.jpg'" alt="核心团队" />
          </div>

          <div class="td2">
            <h4 class="blue_h4">组织架构</h4>
            <i class="framework"></i>
          </div>

          <div class="td3">
            <h4 class="blue_h4">创始人</h4>
            <ul class="csr_ul">
              <li v-for="(item, index) in csrarr" :key="item.id">
                <div class="csr_switch" @click="showAndHide">
                  <span class="open">展开</span>
                  <span class="close">收起</span>
                  <i></i>
                </div>
                <div class="csr_top">
                  <img
                    class="csr_tx"
                    :src="picUrl + 'z' + (index + 1) + '.jpg'"
                    :alt="item.name"
                  />
                  <div class="csr_box">
                    <p class="name">{{ item.name }}</p>
                    <p class="title">{{ item.title }}</p>
                    <p class="university">{{ item.university }}</p>
                  </div>
                </div>
                <transition name="fade">
                  <div class="describe">
                    <div>
                      <p v-for="deit in item.dec" :key="deit">{{ deit }}</p>
                    </div>
                  </div>
                </transition>
              </li>
            </ul>
          </div>
        </div>
        <div class="swiper-slide">
          <!-- 发展历程 -->
          <div class="lc1">
            <div class="swiper-container ssli gallery-thumbs">
              <div class="swiper-wrapper">
                <div class="swiper-slide">2015</div>
                <div class="swiper-slide">2016</div>
                <div class="swiper-slide">2017</div>
                <div class="swiper-slide">2018</div>
                <div class="swiper-slide">2019</div>
                <div class="swiper-slide">2020</div>
              </div>
            </div>
          </div>

          <div class="lc2">
            <!-- Swiper -->
            <div class="swiperfz swiper-container">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="switem in timer"
                  :key="switem.id"
                >
                  <div class="matter_box">
                    <p>{{ switem.year }}</p>
                    <ul>
                      <li v-for="itemss in switem.arr">
                        {{ switem.year }}年{{ itemss }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!-- Add Arrows -->
              <!-- <div class="swiper-button-next"></div>
              <div class="swiper-button-prev"></div> -->
            </div>
          </div>

          <div class="lc3">
            <div class="heng_box">
              <h4 class="blue_h4">获得融资</h4>
              <div>
                2015年10月，获得投资专家张鹏（美国笛卡尔资本中国首席代表）的个人种子轮投资。<br />
                2016年3月，获“中国汽车经销商”自媒体、“梵天咨询机构“天使轮战略投资。<br />
                2016年6月，获国内明星资本“启赋资本”Pre-A轮3000万元投资。<br />
                2018年2月，获得由建银国际、清华启迪联合领投，Per-A轮投资者启赋资本继续跟投的近亿元B轮融资。
              </div>
            </div>

            <img class="rzpic" :src="picUrl + 'rz.jpg'" alt="" />
          </div>

          <div class="lc4">
            <div class="heng_box">
              <h4 class="blue_h4">车镇荣誉</h4>
              <div>
                经过快速的发展与沉淀，车镇已成为国内领先的汽车B2B产业链电商平台。四年来，车镇曾三次荣获“中国汽车互联网+创新100强”的殊荣，在豪华汽车和平行进口车的流通及金融服务上引领全国，获得行业内的高度好评。
              </div>
            </div>

            <ul class="ry_ul">
              <li v-for="item in honorList" :key="item.ids">
                <img :src="item.thumb" alt="" />
                <p>{{ item.title }}</p>
              </li>
            </ul>

            <a
              class="lookmore"
              v-if="honorHide"
              href="javascript:void(0)"
              @click="honorMore"
              >查看全部</a
            >
            <Loading :show="loadingShow" />
          </div>
        </div>
        <div class="swiper-slide">
          <!-- 车商私董会 -->
          <div class="sdh1">
            <div class="heng_box">
              <h4 class="blue_h4">汽车经销商私董会</h4>
              <div>
                2016年10月26日，车镇在南山区数字技术园主办了第一届深圳平行口车商私董会，通过深入交流，展开头脑风暴，收获知识、经验。。<br />
                如今，车镇自主办车商私董会以来，已经走过了4年时光，在广东深圳、东莞、清远、珠海等地前后共举办了超过10场经销商会议。 。<br />
                在车镇人的不懈坚持坚和全体车商的一致努力下，由车镇举办的车商私董会已得到华南各省乃至全国各界车商的广泛关注和高度认可。一场私董会都是一次激烈的智慧交锋，车商们在思想碰撞中共同成长。
              </div>
            </div>
          </div>

          <div class="wh2">
            <div class="gary_tit">历届私董会</div>
            <ul class="wh2_ul">
              <li
                v-for="(item, index) in cslist"
                :key="item.id"
                @click="goInfo(item)"
              >
                <img :src="item.url" :alt="item.title" />
                <div>
                  <p>{{ item.title }}</p>
                  <span>{{ item.describe }}</span>
                </div>
              </li>
            </ul>

            <a
              class="loading_more"
              v-if="cslist.length == 3"
              href="javascript:void(0)"
              @click="goGameFoto(2)"
              >查看更多</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import { getDevelopmentHistory, getCzHonorList, getAlbumList } from "@/api/all";
import Loading from "@/components/loading";
export default {
  name: "coreteam",
  components: {
    Loading,
  },
  data() {
    return {
      picUrl: this.$root.picUrl,
      honorData: {
        page: 1,
        limit: 10,
      },
      arr: ["企业文化", "核心团队", "发展历程", "车商私董会"],
      arr1: [
        {
          tit: "让车商更会卖车",
          dec: "使命 mission",
        },
        {
          tit: "全新汽车产业生态链",
          dec: "愿景 vision",
        },
        {
          tit: "务实、创新、共建、共赢",
          dec: "理念 idea",
        },
      ],
      csrarr: [
        {
          name: "冯璋",
          title: "CEO",
          university: "深圳大学  国际金融",
          dec: [
            "深圳市平行进口汽车商会副会长;",
            "曾获中国汽车流通协会“年度风云人物”;",
            "20年汽车流通行业经验、10年4S集团运营总经理、参与20个汽车品牌管理、2年平行进口车连锁店投资运营经验。",
          ],
        },
        {
          name: "杨希",
          title: "COO",
          university: "西华大学   学士学位",
          dec: [
            "16年汽车流通行业经验;",
            "8年4S集团售后、客服运营管理经验;",
            "管理超2000人员工团队，20万客户，年营业额超10亿元;对运营、客户管理、大数据分析等具备丰富经验与优势。",
          ],
        },
        {
          name: "张磊",
          title: "CTO",
          university: "西南交大  MBA  硕士学位",
          dec: [
            "19年IT从业经验;",
            "9年金碟ERP开发和项目管理经验;",
            "3年汽车经销商集团ERP总监;",
            "3年互联网创业及运作经验。",
          ],
        },
      ],
      timer: [],
      honorList: [],
      yglist: [],
      cslist: [],
      timerIdx: 0,
      honorHide: true,
      loadingShow: false,
      idx: 0,
    };
  },
  created() {
    this.changeMenu(0);
    this.$nextTick(() => {
      this.inits();
    });
    window.addEventListener("scroll", this.floatingRoof);
  },
  methods: {
    floatingRoof() {
      let scrolltop =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset;
      let domImg = document.getElementsByClassName("abusm0")[0];
      let domTop = document.getElementsByClassName("abus_menu")[0];
      if (scrolltop >= domImg.scrollHeight) {
        domTop.style.position = "fixed";
        domTop.style.top = "0.88rem";
        domTop.style.left = "0";
        domTop.style.zIndex = "2";
      } else {
        domTop.style.position = "unset";
      }
    },
    changeMenu(idx) {
      switch (idx) {
        case 0:
          getAlbumList({ type: 1, page: 1, limit: 3 }).then((response) => {
            this.yglist = response.data;
          });
          break;
        case 2:
          this.honorData = {
            page: 1,
            limit: 10,
          };
          this.honorList = [];
          this.honorFun();
          this.getHisFun();
          break;
        case 3:
          getAlbumList({ type: 2, page: 1, limit: 3 }).then((response) => {
            this.cslist = response.data;
          });
          break;
      }
    },
    inits() {
      let that = this;
      var galleryThumbs = new Swiper(".abus_menu", {
        initialSlide: this.idx,
        slidesPerView: 4,
        observer: true,
        observeParents: true,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      });
      var galleryTop = new Swiper(".gallery-top", {
        initialSlide: this.idx,
        observer: true,
        observeParents: true,
        thumbs: {
          swiper: galleryThumbs,
        },
        on: {
          slideChangeTransitionStart: function () {
            that.changeMenu(this.activeIndex);
          },
        },
      });
    },
    // 发展历史
    getHisFun() {
      getDevelopmentHistory().then((response) => {
        this.timer = response.data;
      });
      this.$nextTick(() => {
        this.initSwiper();
      });
    },
    // 车镇荣誉列表
    honorFun() {
      this.loadingShow = true;
      getCzHonorList(this.honorData).then((response) => {
        response.data.length == 0
          ? (this.honorHide = false)
          : (this.honorHide = true);
        this.honorList = response.data;
        this.loadingShow = false;
      });
    },
    // 荣誉加载
    honorMore() {
      if ((this.honorHide = false)) return false;
      this.honorData.page++;
      getCzHonorList(this.honorData).then((response) => {
        response.data.length == 0
          ? (this.honorHide = false)
          : (this.honorHide = true);
        this.honorList = this.honorList.concat(response.data);
        this.loadingShow = false;
      });
    },
    initSwiper() {
      var swiperDev = new Swiper(".ssli", {
        slidesPerView: 4,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
      });

      var swiperDevTop = new Swiper(".swiperfz", {
        speed: 900,
        centeredSlides: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: {
          swiper: swiperDev,
        },
        on: {
          slideChangeTransitionStart: function () {},
        },
      });

      swiperDevTop.init();
    },
    goGameFoto(num) {
      this.$router.push({
        path: "/Gamefoto",
        query: {
          isok: num,
        },
      });
    },
    showAndHide(event) {
      let _el = event.currentTarget;
      let _elpar = event.currentTarget.parentElement;
      if (_el.getAttribute("class") === "csr_switch active") {
        _el.setAttribute("class", "csr_switch");
        _elpar.setAttribute("class", "");
      } else {
        _el.setAttribute("class", "csr_switch active");
        _elpar.setAttribute("class", "open");
      }
    },
    goInfo(item) {
      // 直接跳转公众号文章
      this.$router.push({
        path: "/Album",
        query: {
          id: item.id,
          url: item.url,
          describe: item.describe,
          title: item.title,
        },
      });
    },
  },
  deactivated() {
    window.removeEventListener("scroll", this.floatingRoof, false);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.floatingRoof, false);
  },
};
</script>
<style>
@import "../../../node_modules/swiper/dist/css/swiper.min.css";
</style>


// WEBPACK FOOTER //
// src/views/aboutus/aboutusm.vue